<template>
  <div class="d-block d-lg-none d-print-none">
    <nav class="nav_bottom" v-if="showBottom">
      <a @click="redefinir()" class="nav__link" v-if="showBtnSimulacao">
        <span class="nav__icon ti-view-list-alt"></span>
        <span class="nav__text">Nova Simulação</span>
      </a>
      <a @click="modalOpen('personalizar')" class="nav__link" v-if="showBtnPersonalizar">
        <b-spinner
          small
          variant="success"
          v-if="!getLoadAllData()"
          title="Aguarde o carregamento dos dados"
        ></b-spinner>
        <span class="nav__icon ti-pencil-alt" v-if="getLoadAllData()"></span>
        <span class="nav__text">Personalizar</span>
      </a>
      <a @click="modalOpen('envio')" class="nav__link" v-if="showBtnEmail">
        <b-spinner
          small
          variant="success"
          v-if="!getLoadAllData()"
          title="Aguarde o carregamento dos dados"
        ></b-spinner>
        <span class="nav__icon ti-email" v-if="getLoadAllData()"></span>
        <span class="nav__text">Salvar/Enviar</span>
      </a>
      <a
        @click="modalOpen('impressao')"
        class="nav__link"
        v-if="showBtnPrint">
        <b-spinner
          small
          variant="success"
          v-if="!loadingSession"
          title="Aguarde o carregamento dos dados"
        ></b-spinner>
        <span class="nav__icon ti-printer" v-if="loadingSession"></span>
        <span class="nav__text">Imprimir</span>
      </a>
    </nav>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      tipoFilter: null,
      showBottom: false,
      showBtnPersonalizar: false,
      showBtnSimulacao: false,
      showBtnEmail: false,
      showBtnPrint: false,
      loadingSession: true
    }
  },
  methods: {
    ...mapActions('usuario', ['saveSession']),
    ...mapActions("cenario", ["updateId", "recuperaCenario", "removerPlanos"]),
    async modalOpen(tipo) {
      let exibirCenarios = this.cenarios &&
      this.cenarios.map(
        c => c.operadoras.map(
          o => o.grupos.length
        ).reduce((a, b) => a + b, 0)
      ).reduce((a, b) => a + b, 0) > 0
      if (exibirCenarios) {
        if (this.getLoadAllData()) {
          if (tipo == 'personalizar') {
            await this.loadFilters()
            this.$bvModal.show('modal-filter')
          } else if (tipo == 'envio') {
            this.$bvModal.show('modal-share')
          } else if (tipo == 'impressao') {
            this.print()
          }
        }
      } else {
        swal("É necessário adicionar alguns planos para enviar ou imprimir", {
          icon: "warning",
        });
      }
    },
    async loadFilters() {
      this.filters = this.getFilters
    },
    getLoadAllData() {
      return !this.loadingCenarios
    },
    async print() {
      const id = localStorage.getItem(process.env.VUE_APP_CLIENT_ID);
      const json = JSON.parse(id);
      const user = json?.user;

      this.loadingSession = false
      await this.saveSession({
        id: user.token,
        data: {
          user: user,
          cenarios: this.cenarios,
          filters: this.getFilters,
          rows: this.getRows
        }
      })
      this.loadingSession = true
      const cotacao_id = localStorage.getItem('cotacao_id')

      const cenario = this.cenarios[0]
      const operadora = cenario.operadoras[0]
      const filtros = operadora.filtros

      let routeData = this.$router.resolve({
        name: "simulacaoDetalhePrint",
        params: {
          id: cotacao_id ? 'cotacao' : operadora.id
        },
        query: {
          tipo_plano: filtros.tipo_plano,
          contratacao: filtros.contratacao,
          compulsorio: filtros.compulsorio == 2 ? '' : filtros.compulsorio == 1 ? 's' : 'n',
          coparticipacao: filtros.coparticipacao == 2 ? '' : filtros.coparticipacao == 1 ? 's' : 'n',
          acomodacao: filtros.acomodacao == 2 ? '' : filtros.acomodacao == 1 ? 'a' : 'e',
          regras_aceitacao: filtros.regras_aceitacao ? 's' : 'n',
          cidade: filtros.cidade ? filtros.cidade.id : '',
          credenciado: filtros.credenciado ? filtros.credenciado : '',
          entidade: filtros.entidade_profissao?.tipo == 'e' ? filtros.entidade_profissao.value.id : '',
          profissao: filtros.entidade_profissao?.tipo == 'p' ? filtros.entidade_profissao.value.id : '',
          hash: user.token
        },
      });
      window.open(routeData.href, "_blank");
    },
    async redefinir() {
      if (this.cenarios.length > 0) {
        swal({
          title: "Redefinir o simulador ?",
          text: "Após confirmar os grupos e as vidas serão mantidas, mas perderá a configuração dos planos !",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then(async (willDelete) => {
          if (willDelete) {
            this.removerPlanos()
            let id = this.cenarios[0].id
            await this.recuperaCenario({ id: id })
            this.$bvModal.show("modal-idade")
          }
        });
      } else {
        await this.updateId({ id: null })
        await this.recuperaCenario({ id: null })
        this.$bvModal.show("modal-idade")
      }
    },
  },
  computed: {
    ...mapGetters('modalFilter', ['getFilters', 'getRows']),
    ...mapGetters('cenario', {
      cenarios: "getCenarios",
      loadingCenarios: 'getLoading'
    }),
  },
  watch: {
    $route(to, from) {
      if (to.name == 'simulacaoNova' || to.name == 'simulacaoEdit') {
        this.showBottom = true
        this.showBtnSimulacao =  true
        this.showBtnPersonalizar = true
        this.showBtnEmail = true
        this.showBtnPrint = true
      } else {
        this.showBottom = false
        this.showBtnSimulacao =  false
        this.showBtnPersonalizar = false
        this.showBtnEmail = false
        this.showBtnPrint = false
      }
    }
  },
  async mounted() {
    if (this.$router.currentRoute.name == 'simulacaoNova' || this.$router.currentRoute.name == 'simulacaoEdit') {
      this.showBottom = true
      this.showBtnSimulacao =  true
      this.showBtnPersonalizar = true
      this.showBtnEmail = true
      this.showBtnPrint = true
    } else {
      this.showBottom = false
      this.showBtnSimulacao =  false
      this.showBtnPersonalizar = false
      this.showBtnEmail = false
      this.showBtnPrint = false
    }
  }
}
</script>

<style lang="scss" scope>
  .nav_bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 45px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    background-color: #f39c12b8;
    display: flex;
    overflow-x: auto;
    z-index: 10;
    & .nav__link {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-grow: 1;
      min-width: 50px;
      overflow: hidden;
      white-space: nowrap;
      font-family: sans-serif;
      font-size: 13px;
      color: #fff;
      text-decoration: none;
      -webkit-tap-highlight-color: transparent;
      transition: background-color 0.1s ease-in-out;
      &:hover {
        background-color: #ffb949;
      }
      &.active {
        color: #663f00;
      }
      .nav__icon {
        font-size: 15px;
      }
      .nav__text {
        font-size: 10px;
        margin-top: 2px;
      }
    }
  }
</style>
